module.exports = __webpack_public_path__ + "img/service1.5398394d.png";